import React from 'react';
import Separator from '../../../../core/layout/Separator';
import Card from '../../../../core/layout/Card';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import StudentAccessFrequencyTableContainer from './student/StudentAccessFrequencyTableContainer';
import StudentEngagementTableContainer from './student/StudentEngagementTableContainer';
import StudentChurnTableContainer from './student/StudentChurnTableContainer';
import StudentStudyQualityTableContainer from './student/StudentStudyQualityTableContainer';
import PartnerLicensePackageUsageRateTableContainer from './partner/PartnerLicensePackageUsageRateTableContainer';
import PartnerStudentVariationTableContainer from './partner/PartnerStudentVariationTableContainer';
import PartnerAccessFrequencyTableContainer from './partner/PartnerAccessFrequencyTableContainer';

const CustomerSuccessSegmentTab = () => (
  <div>
    <Card title="Partners" collapsible>
      <Row>
        <Column size={6}>
          <PartnerAccessFrequencyTableContainer type="segment" />
        </Column>
        <Column size={6}>
          <PartnerLicensePackageUsageRateTableContainer type="segment" />
        </Column>
      </Row>
      <Separator />
      <Row>
        <Column size={6}>
          <PartnerStudentVariationTableContainer type="segment" />
        </Column>
      </Row>
    </Card>
    <Separator />
    <Card title="Students" collapsible>
      <Row>
        <Column size={6}>
          <StudentAccessFrequencyTableContainer type="segment" />
        </Column>
        <Column size={6}>
          <StudentEngagementTableContainer type="segment" />
        </Column>
      </Row>
      <Separator />
      <Row>
        <Column size={6}>
          <StudentChurnTableContainer type="segment" />
        </Column>
        <Column size={6}>
          <StudentStudyQualityTableContainer type="segment" />
        </Column>
      </Row>
    </Card>
  </div>
);

export default CustomerSuccessSegmentTab;
